import React from 'react'

// Patvirtinimo lapas po globalaus „Buvau čia": parodo nuotrauką ir leidžia
// pasirinkti vietą (artimiausios ~300m spinduliu) arba „tik prisiminimas".
// taskas = { dataUrl, gps } | null
// kandidatai = [{ ...vieta, dist(m) }] — artimiausia pirma
// vieta = pasirinkta vieta | null (null = tik prisiminimas)
function PrisiminimoPatvirtinimas({ taskas, kandidatai, vieta, onPasirink, onSave, onClose, saugoma }) {
  const atidaryta = !!taskas

  function EilRadijas({ aktyvus, antra, virsus, onClick }) {
    return (
      <button
        onClick={onClick}
        style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%', textAlign: 'left', padding: '11px 12px', borderRadius: 10, cursor: 'pointer', border: `1px solid ${aktyvus ? 'rgba(229,168,64,0.45)' : '#2A3B32'}`, background: aktyvus ? 'rgba(229,168,64,0.12)' : 'transparent', marginBottom: 6, fontFamily: 'Syne, system-ui, sans-serif' }}
      >
        <span style={{ width: 18, height: 18, borderRadius: '50%', flexShrink: 0, border: `2px solid ${aktyvus ? '#E5A840' : '#3A4C42'}`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {aktyvus && <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#E5A840' }} />}
        </span>
        <span style={{ minWidth: 0, flex: 1 }}>
          <span style={{ display: 'block', color: '#F0E8D5', fontSize: 14, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{virsus}</span>
          {antra && <span style={{ display: 'block', color: '#7A8A7E', fontSize: 11, marginTop: 2 }}>{antra}</span>}
        </span>
      </button>
    )
  }

  return (
    <>
      <div onClick={saugoma ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1200, opacity: atidaryta ? 1 : 0, pointerEvents: atidaryta ? 'auto' : 'none', transition: 'opacity 0.3s ease' }} />
      <div style={{ position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 1201, background: '#1E2E27', borderRadius: '20px 20px 0 0', borderTop: '1px solid #2A3B32', transform: atidaryta ? 'translateY(0)' : 'translateY(100%)', transition: 'transform 0.35s cubic-bezier(0.32,0.72,0,1)', maxHeight: '88dvh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0 4px' }}>
          <div style={{ width: 36, height: 4, borderRadius: 2, background: 'rgba(240,232,213,0.2)' }} />
        </div>

        <div style={{ padding: '6px 20px calc(18px + env(safe-area-inset-bottom))', overflowY: 'auto' }}>
          <h2 style={{ fontFamily: "'Lora', Georgia, serif", color: '#F0E8D5', fontSize: 21, fontWeight: 500, margin: '4px 0 12px' }}>Naujas prisiminimas</h2>

          {taskas && taskas.dataUrl && (
            <div style={{ width: '100%', height: 150, borderRadius: 12, overflow: 'hidden', background: '#141F1A', marginBottom: 16 }}>
              <img src={taskas.dataUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
          )}

          <div style={{ color: '#7A8A7E', fontSize: 10, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 10 }}>
            {kandidatai && kandidatai.length ? 'Kur tai?' : 'Vieta'}
          </div>

          {kandidatai && kandidatai.map(k => (
            <EilRadijas
              key={k.id}
              aktyvus={vieta && vieta.id === k.id}
              virsus={k.pavadinimas}
              antra={`${Math.round(k.dist)} m nuo tavęs${k.miestas ? ` · ${k.miestas}` : ''}`}
              onClick={() => onPasirink(k)}
            />
          ))}

          <EilRadijas
            aktyvus={!vieta}
            virsus="Tik prisiminimas"
            antra="Be konkrečios vietos — liks žemėlapyje, kur nufotkinai"
            onClick={() => onPasirink(null)}
          />

          <button
            onClick={onSave}
            disabled={saugoma}
            style={{ width: '100%', height: 52, borderRadius: 12, background: '#E5A840', color: '#141F1A', border: 'none', fontFamily: "'Lora', Georgia, serif", fontSize: 17, fontWeight: 600, cursor: saugoma ? 'default' : 'pointer', marginTop: 14, opacity: saugoma ? 0.7 : 1 }}
          >
            {saugoma ? 'Saugoma…' : 'Išsaugoti'}
          </button>
        </div>
      </div>
    </>
  )
}

export default PrisiminimoPatvirtinimas
